// extracted by mini-css-extract-plugin
module.exports = {"Recommendation":"Recommendation_Recommendation__21194","Recommendation__product":"Recommendation_Recommendation__product__2qSXr"};